<!-- Title (if provided) -->
@if (title()) {
  <div class="hx-progress-bar__title">{{ title() }}</div>
}

<!-- Linear Variant -->
@if (variant() === 'linear') {
  <div class="hx-progress-bar__container">
    <div class="hx-progress-bar__track">
      <!-- Determinate Fill -->
      @if (!isIndeterminate() && !segments()?.length) {
        <div class="hx-progress-bar__fill" [style.width.%]="clampedValue()"></div>
      }

      <!-- Indeterminate Fill -->
      @if (isIndeterminate()) {
        <div class="hx-progress-bar__fill hx-progress-bar__fill--indeterminate"></div>
      }

      <!-- Segmented Fill -->
      @if (segments()?.length) {
        @for (segment of segments(); track $index) {
          <div
            [class]="'hx-progress-bar__segment hx-progress-bar__segment--context-' + (segment.context || context())"
            [attr.aria-label]="segment.label"
            [style.flex-basis.%]="segment.value"></div>
        }
      }
    </div>

    <!-- Pin Indicator -->
    @if (shouldShowPin()) {
      <div
        class="hx-progress-bar__pin"
        [style.left.%]="pinPosition()"
        [title]="pinLabel() || clampedValue() + '%'"></div>
    }
  </div>
}

<!-- Circular Variant -->
@if (variant() === 'circular') {
  <svg class="hx-progress-bar__svg" [attr.height]="diameter()" [attr.viewBox]="viewBox()" [attr.width]="diameter()">
    <!-- Background Circle (Track) -->
    <circle
      class="hx-progress-bar__circle-track"
      fill="none"
      [attr.cx]="diameter() / 2"
      [attr.cy]="diameter() / 2"
      [attr.r]="radius()"
      [attr.stroke-width]="strokeWidth()" />

    <!-- Progress Circle (Fill) -->
    <circle
      class="hx-progress-bar__circle-fill"
      fill="none"
      [attr.cx]="diameter() / 2"
      [attr.cy]="diameter() / 2"
      [attr.r]="radius()"
      [attr.stroke-dasharray]="circumference()"
      [attr.stroke-dashoffset]="isIndeterminate() ? circumference() * 0.75 : strokeDashOffset()"
      [attr.stroke-width]="strokeWidth()"
      [attr.transform]="'rotate(-90 ' + diameter() / 2 + ' ' + diameter() / 2 + ')'"
      [class.hx-progress-bar__circle-fill--indeterminate]="isIndeterminate()" />
  </svg>
}

<!-- Status (if provided) -->
@if (status()) {
  <div class="hx-progress-bar__status">{{ status() }}</div>
}

<!-- Custom Content Slot -->
<ng-content select="[hxProgressBarLabel]" />
